// extracted by mini-css-extract-plugin
module.exports = {"main_nav":"main_nav-HJrnZRTr","user":"user-1UNgQJZ9","box":"box-JYDtEdQg","ad":"ad-24mlf2Vy","search":"search-3Gs8nNwb","logo":"logo-2YPra3u6"};